import { LEVELS_PER_CHAPTER } from "@highmarch/app";
import { BalanceData } from "@highmarch/domain";

export type Biome = "meadow" | "marsh" | "ashlands";

export interface ChapterInfo { index: number; first: number; last: number; name: string; biome: Biome }

/** The biome art (art/interface/chapters) covers this many chapters each: meadow, marsh, ashlands. */
const CHAPTERS_PER_BIOME = 2;
const LEVELS_PER_BIOME = LEVELS_PER_CHAPTER * CHAPTERS_PER_BIOME;

/** Ten levels per chapter (@highmarch/app LEVELS_PER_CHAPTER). */
export function chapterOf(B: BalanceData, level: number, levelCount: number): ChapterInfo {
  const index = Math.floor((level - 1) / LEVELS_PER_CHAPTER);
  const first = index * LEVELS_PER_CHAPTER + 1;
  return { index, first, last: Math.min(levelCount, first + LEVELS_PER_CHAPTER - 1), name: B.level(first).name, biome: biomeOf(level) };
}

export function biomeOf(level: number): Biome { return level <= LEVELS_PER_BIOME ? "meadow" : level <= 2 * LEVELS_PER_BIOME ? "marsh" : "ashlands"; }
